import React, { useEffect, useState } from "react";  
import { useAxios } from "../../../../common_nextgen/axios/AxiosHelper";  
import useCustomNavigate from "../../../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import getBackendUrl from "../../../../environment/BackendService";  
import { fetchDropdownValues } from "../../../../common_nextgen/common_components/dropdown/DropdownHelper";  
import { useLocation } from "react-router-dom";  
import { ROUTE_PATHS } from "../../../../common_nextgen/utils/Constants";  
import { useToast } from "../../../../common_nextgen/hooks/ToastContext";
import { downloadCSV } from "../../../../common_nextgen/utils/UtilFunctions";

  
const useCopayScheduleStep = (onSelect, hideModal, selectParams) => {  
  const [data, setData] = useState([]); /* Copay Schedule Step Data */  
  const { axios_helper_no_header } = useAxios();
  const [paramsData, setParamsData] = useState({  
    schedule: "",  
    description: "",  
    noteExistenceStatus: "",  
    searchCriteria: "",  
  }); /* */  
  const [first, setFirst] = useState(0);  
  const [rows, setRows] = useState(10);  
  const [totalRecords, setTotalRecords] = useState(0);  
  const [rowData, setRowData] = useState("");  
  const [currentPage, setCurrentPage] = useState(0);  
  const [selectedRows, setSelectedRows] = useState([]);  
  const navigateToPage = useCustomNavigate();  
  const [dropdownValues, setDropdownValues] = useState({});  
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);  
  const [selectedOption, setSelectedOption] = useState("no");  
  const toast = useToast();  
  const location = useLocation();  
  const {  } = ROUTE_PATHS;  
  
  const screen_title = "Copay Schedule Step";  
  const screenNumber = "RCCSC008";  
  
  /* Search form fields that needs to be shown for filtering */  
  const formFields = [  
    {  
      fieldLabel: "Schedule",  
      name: "schedule",  
      label: "Schedule",  
      type: "text",  
      fieldNature: "readOnly",  
      value: "",  
      maxLength: 10,  
    },  
    {  
      fieldLabel: "Description",  
      name: "description",  
      label: "Description",  
      type: "text",  
      fieldNature: "readOnly",  
      value: "",  
      maxLength: 25,  
    },  
    {  
      fieldLabel: "Note Existence Status",  
      name: "noteExistenceStatus",  
      label: "-",  
      type: "text",  
      fieldNature: "readOnly",  
      value: "",  
      maxLength: 1,  
    },  
    {  
      fieldLabel: "CSC Step Nbr",  
      name: "searchCriteria",  
      label: "Step Number",  
      type: "text",  
      fieldNature: "editable",  
      value: "",  
      maxLength: 2,  
    },  
  ];  
  
  /* Dropdown options fields that needs to be fetched with API */  
  const dropdownOptions = [];  
  
  const dropdownCondition = {  
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),  
  }; 
  
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        hideModal();
      },
      button_key: "F12",
    },
  ];
  
  /* ACTION BUTTONS info that needs to be displayed on the page */  
  const ctaButtons = [  
    // {  
    //   button_label: "Add Copay Schedule Step",  
    //   button_handeler: () => {  
    //     navigateToPage(ADD_COPAY_SCHEDULE_STEP);  
    //   },  
    //   button_key: "F6",  
    // },  
    {
      button_label: "Export as CSV",
      button_handeler: () => {
        exportAsCSV();
      },
      button_key: "",
    },  
    // {  
    //   button_label: "Back",  
    //   button_handeler: () => {  
    //     navigateToPage(DISPLAY_COPAY_SCHEDULE_STEP);  
    //   },  
    //   button_key: "F12",  
    // },  
    // {  
    //   button_label: "Note",  
    //   button_handeler: () => {  
    //     navigateToPage(COPAY_SCHEDULE_STEP_NOTE);  
    //   },  
    //   button_key: "F14",  
    // },  
  ];  
  
  /* Gear Icon Menu option CTAs */  
  const menuOptions = [  
    {  
      label: "Select",  
      icon: <span className="material-icons">check</span>,  
      command: () => {  
      },  
    },  
    {  
      label: "Display",  
      icon: <span className="material-icons">visibility</span>,  
      command: () => {  
      },  
    },  
  ];  
  
  /* Data table column info. */  
  const columnDef = [  
    {  
      header: "Step",  
      field: "stepNo",  
    },  
    {  
      header: "$Amt/Qty/Day",  
      field: "maxAmtQty",  
    },  
    {  
      header: "DS",  
      field: "daysSupply",  
    },  
    {  
      header: "$/Factor",  
      field: "amtFactor",  
    },  
    {  
      header: "Percent",  
      field: "percent",  
    },  
    {  
      header: "$ Amount",  
      field: "maxCoPay",  
    },  
    {  
      header: "Percent",  
      field: "maxCoPayPercent",  
    },  
    {  
      header: "Basis",  
      field: "maxCoPayCalcBasis",  
    },  
    {  
      header: "CompCd",  
      field: "coPayCodeOverride",  
    },  
    {  
      header: "Min",  
      field: "minCoPayOverride",  
    },  
    {  
      header: "Basis",  
      field: "cscBasis",  
    },  
    {  
      header: "Overage",  
      field: "maxCopayCoverage",  
    } 
  ];  
  
  /* Param Key which used as bridge between various operations on tabluar data */  
  const parmKey = "stepNo";  
  
  /* Handler that fetches the data */  
  const fetchData = async () => {  
    const page = first / rows;  
    try {  
      const raw_response = await axios_helper_no_header(  
        "GET",  
        `api/rccshp`,  
        null,  
        {  
          page: page,  
          size: rows,  
          ...paramsData,  
        }  
      );  
      const response = raw_response.responseData;  
      const pageResponse = raw_response.responsePaginationDTO;  
      if (response.length === 0) {  
        setData([]);  
        setTotalRecords(0);  
        toast.current.show({  
          severity: "info",  
          summary: "",  
          detail: response.responseStatus.message,  
          life: 3000,  
        });  
      } else {  
        setData(response);   
        setTotalRecords(pageResponse.totalRecords); // Assuming the API returns totalRecords  
      }  
    } catch (error) {  
      console.error("Error fetching data:", error);  
      setData([]);  
      setTotalRecords(0);  
    }  
  };  
  
  const fetchDropdownData = async (dataDropdown) => {  
    try {  
      const response = await fetchDropdownValues(dataDropdown);  
      setDropdownValues(response);  
    } catch (error) {  
      console.error("Error fetching dropdown values:", error);  
    }  
  };  
  
  useEffect(() => {  
    fetchDropdownData(dropdownCondition);  
  }, []);  
  
  useEffect(() => {  
    fetchData(); // Initial fetch with page 0 and page size 10  
  }, [paramsData, rows, currentPage, selectedOption]);  
  
  const onPageChange = (event) => {  
    setFirst(event.first);  
    setCurrentPage(event.page);  
    setRows(event.rows);  
  };    


  const exportAsCSV = async () => {
    const queryParams = { ...paramsData };
    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/rccshp/exportcsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };
  
  const updateParamData = (data) => {  
    setFirst(0);  
    setCurrentPage(0);  
    setParamsData(data);  
  };  
  
  return {  
    screenNumber,  
    screen_title,  
    formFields,  
    dropdownValues,  
    paramsData,  
    updateParamData,  
    ctaButtons,  
    data,  
    parmKey,  
    menuOptions,  
    columnDef,  
    setRowData,  
    selectedRows,  
    setSelectedRows,  
    first,  
    rows,  
    totalRecords,  
    currentPage,  
    onPageChange,  
    isConfirmationModalOpen,  
    setSelectedOption, 
    leftButtons 
  };  
};  
  
export default useCopayScheduleStep;  